import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.cil = bracketIndenting({
	line: "//",
})
